import { env } from "./EnvironmentConfig";
import { SIDE_NAV_COLLAPSED_STORAGE_KEY } from "constants/ThemeConstant";

const readNavCollapsed = () => {
  try {
    return localStorage.getItem(SIDE_NAV_COLLAPSED_STORAGE_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const APP_NAME = "Majestic";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const APP_MENU_PATH = "/menu";
export const AUTH_PREFIX_PATH = "/auth";

export const THEME_CONFIG = {
  navType: "SIDE",
  sideNavTheme: "SIDE_NAV_LIGHT",
  navCollapsed: readNavCollapsed(),
  topNavColor: "#2f6fe0",
  headerNavColor: "#0E2A47",
  locale: "en",
  currentTheme: "light",
};
